import React from 'react';

const Reports: React.FC = () => {
  return (
    <></>
  )
}

export default Reports;